import { unref as _unref, resolveComponent as _resolveComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue";

import { fetchApi } from '/Users/ytx/ytx/projects/jxpj/web/jxpj-client/src/server/auto-import.js';
import { ref, onMounted } from 'vue';
export default {
  __name: 'mg-org-dep-select',
  setup(__props) {
    const {
      loading,
      runAsync: myOrgDepGetListApi
    } = fetchApi('myOrgDep.getList', {
      showError: false
    });
    const list = ref([]);
    const loadList = async () => {
      const {
        error,
        rows
      } = await myOrgDepGetListApi({});
      if (error) return Promise.resolve(false);
      list.value = rows;
    };
    onMounted(() => {
      loadList();
    });
    return (_ctx, _cache) => {
      const _component_vxe_select = _resolveComponent("vxe-select");
      return _openBlock(), _createBlock(_component_vxe_select, _mergeProps({
        options: _unref(list),
        loading: _unref(loading),
        "option-props": {
          value: 'id',
          label: 'name'
        }
      }, _ctx.$attrs), null, 16, ["options", "loading"]);
    };
  }
};